<template>
    <div class="up-btn" @click="handelClick">
        <svg-icon :name="like" size="19" class="up-btn__icon"></svg-icon>
        <span class="up-btn__font">{{ `  点赞  ${number}` }}</span>
    </div>
</template>

<script>
import { error } from '../../utils/message';
import SvgIcon from '../svg/svg-icon';
import { topicVote } from '../../service/user';
export default {
    components: { SvgIcon },

    props: {
        num: {
            type: String,
            default: ''
        },

        id: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            like: 'like',
            number: 0
        };
    },
    mounted() {
        this.num
            ? this.num.split(',').forEach((item) => {
                  if (item == this.$store.state.user.userInfo.id) {
                      this.like = 'like-white';
                  }
              })
            : '';
        this.number = this.num ? this.num.split(',').length : 0;
    },
    methods: {
        async handelClick() {
            if (!this.$store.state.user.userInfo.token) {
                await this.$router.push({ name: '登录', query: { from: this.$route.fullPath } });
                return;
            }

            this.$emit('handel-click');

            let res;

            try {
                res = await topicVote(this.id);
            } catch (err) {
                return error(err);
            }

            if (res === 1) {
                this.like = 'like-white';
                this.number += 1;
            }
            if (res === 0) {
                this.like = 'like';
                this.number -= 1;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.up-btn {
    width: 180px;
    margin: 60px auto 0;
    height: 40px;
    cursor: pointer;
    background: #047aff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    &__icon {
        margin-right: 10px;
    }
    &__font {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
    }
}
</style>
